import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';
import { TopBarWrapperComponent, DashboardType } from '../top-bar-wrapper/top-bar-wrapper.component';
import { MessagingRoutePaths, RoutePaths } from '../../shared/types/common';
import { MessagingService } from '../../services/messaging.service';
import { AssetVersionPipe } from '../../pipes/asset-version.pipe';
import { GroupingTypeKey, groupingTypes, groupingTypesLabels, groupingTypePosthogValues, THEMES } from './types';
import { TabsComponent } from '../../shared/components/tabs/tabs.component';
import { PosthogService } from '../../services/posthog.service';
import { DashboardService } from '../../services/dashboard.service';
import { PosthogEventName, PosthogEventCode } from '../../services/types';

@Component({
  selector: 'app-messaging-screen',
  imports: [TopBarWrapperComponent, RouterOutlet, NgClass, NgIf, AssetVersionPipe, TabsComponent],
  templateUrl: './messaging-screen.component.html',
  styleUrl: './messaging-screen.component.scss'
})
export class MessagingScreenComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private posthogService = inject(PosthogService);
  private dashboardService = inject(DashboardService);
  protected readonly DashboardType = DashboardType;
  protected readonly MessagingRoutePaths = MessagingRoutePaths;
  public isGalleryHovered = false;

  public activeTab = signal<string>(MessagingRoutePaths.MARKETING_REPORT);

  public activeGroupingType = signal<GroupingTypeKey>(THEMES);

  public groupingTypesLabels = groupingTypesLabels;
  ngOnInit(): void {
    const segments = this.router.url.split('/');
    const tab = segments[segments.indexOf(RoutePaths.MESSAGING) + 1];
    this.activeTab.set(tab || MessagingRoutePaths.MARKETING_REPORT);
    this.activeGroupingType.set(THEMES);
  }

  navigateTo(tab: MessagingRoutePaths): void {
    if (this.activeTab() !== tab) {
      this.activeTab.set(tab);
      this.router.navigate([tab], { relativeTo: this.route });
    }
  }
  switchGroupingTypeTab(tab: string): void {
    const key = Object.entries(groupingTypes).find(([, label]) => label === tab)?.[0] as GroupingTypeKey;
    if (key && key !== this.activeGroupingType()) {
      this.activeGroupingType.set(key);
      this.trackGroupBySelected(key);
    }
  }

  private trackGroupBySelected(groupingType: GroupingTypeKey): void {
    const filters = this.dashboardService.brandsFilters();
    this.posthogService.capture(PosthogEventName.GROUP_BY_SELECTED, {
      [PosthogEventCode.MY_BRAND]: filters.myBrand?.key ?? '',
      [PosthogEventCode.MY_COMPETITORS]: filters.myCompetitors.map(c => c.key).join(';'),
      [PosthogEventCode.GROUP_BY_OPTION]: groupingTypePosthogValues[groupingType],
    });
  }

  get shouldShowGroupingTypes(): boolean {
    return this.activeTab() === MessagingRoutePaths.MARKETING_REPORT;
  }
}
